import React from "react"

interface FieldProps {
  label: string
  required?: boolean
  children: React.ReactNode
}

export const inputCls =
  "w-full bg-transparent border-b border-neutral-600 focus:border-emerald-400 outline-none text-white text-sm py-2 transition-colors placeholder:text-neutral-600"

export const selectCls =
  "w-full bg-transparent border-b border-neutral-600 focus:border-emerald-400 outline-none text-white text-sm py-2 transition-colors appearance-none cursor-pointer"

export const Field: React.FC<FieldProps> = ({ label, required, children }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-semibold text-neutral-400 uppercase tracking-widest">
      {label}
      {required && <span className="text-emerald-400 ml-1">*</span>}
    </label>
    {children}
  </div>
)